import { useSelector } from "react-redux";
import FeedbackPrincipal from "./principal/FeedbackPrincipal.js";
import FeedbackTeacher from "./teacher/FeedbackTeacher.js";
import FeedbackStudent from "./student/FeedbackStudent.js";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";

function Feedback() {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <FeedbackPrincipal />;
    }
    if (state.auth.user.is_teacher) {
      return <FeedbackTeacher />;
    }
    if (state.auth.user.is_student) {
      return <FeedbackStudent />;
    }

    return <PermissionDenied />;
  }
}

export default Feedback;
